<template>
  <div class="flex items-center">
    <span :style="`background-color:${status.color.code}`"
      class="rounded-xl py-1 px-4 text-white text-xs text-center shadow-md">{{ $i18n.locale == "fa" ? status.fa_title :
        status.en_title }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: Object,
      default: () => {
        return {
          fa_title: "",
          en_title: "",
          color: {
            code: "",
          },
        };
      },
    },
  },

};
</script>
